import React from 'react';
import { Descriptions } from 'antd';

const DataDisplay = props => {
  const {
    info,
    title
  } = props;

  const itemGroups = [
    { name: 'member_name', label: '申请人' },
    { name: 'add_time', label: '申请时间' },
    { name: 'member_levelid', label: '代理等级' },
    { name: 'team_achi_total', label: '社群净采购额' },
    { name: 'team_num', label: '社群未注销，未拉黑人数' },
    { name: 'shop_name', label: '店铺名称' },
    { name: 'serial_code', label: '序列号' },
    { name: 'revenue', label: '批发商总收入' },
    { name: 'pay', label: '批发商总支出' },
    { name: 'total_release', label: '已解冻批发利润' },
    { name: 'total_wait', label: '待解冻批发利润' },
    { name: 'handle_user_name', label: '处理人' },
    { name: 'status', label: '处理结果' },
    { name: 'update_time', label: '处理时间' },
    { name: 'team_achi_365_total', label: '社群365天净采购额' },
    { name: 'shop_name', label: '店铺名称' },
    { name: 'serial_code', label: '序列号' },
    { name: 'shop_time', label: '入驻时间' },
    { name: 'address', label: '常驻地区' },
    { name: 'shop_num', label: 'KA卖家数量' },
    { name: 'achievement', label: 'KA卖家个人净采购额' },
    { name: 'order_num', label: '笔数' },
  ]

  const domMemo = React.useMemo(()=>{
    const keys = Object.keys(info);

    return keys.length && keys.map((item, idx) => {
      const infoItem = itemGroups.find(nameItem => nameItem.name === item);

      return infoItem?<Descriptions.Item key={idx} label={infoItem.label}>{info[item]}</Descriptions.Item>:''
    })
  },[info,itemGroups])


  return (
    <Descriptions title={title}>
      {domMemo}
    </Descriptions>
  );
};

export default DataDisplay;
